export const API_GET_ACTIVE_PROMOTIONS_PENDING = "API_GET_ACTIVE_PROMOTIONS_PENDING";
export const API_GET_ACTIVE_PROMOTIONS_SUCCESS = "API_GET_ACTIVE_PROMOTIONS_SUCCESS";
export const API_GET_ACTIVE_PROMOTIONS_FAILURE = "API_GET_ACTIVE_PROMOTIONS_FAILURE";
export const API_GET_PROMO_BY_ID_PENDING = "API_GET_PROMO_BY_ID_PENDING";
export const API_GET_PROMO_BY_ID_SUCCESS = "API_GET_PROMO_BY_ID_SUCCESS";
export const API_GET_PROMO_BY_ID_FAILURE = "API_GET_PROMO_BY_ID_FAILURE";
export const GET_PROMOTION_BY_SHORT_ID_PENDING = "GET_PROMOTION_BY_SHORT_ID_PENDING";
export const GET_PROMOTION_BY_SHORT_ID_SUCCESS = "GET_PROMOTION_BY_SHORT_ID_SUCCESS";
export const GET_PROMOTION_BY_SHORT_ID_FAILURE = "GET_PROMOTION_BY_SHORT_ID_FAILURE";